import { isBluTRV, isTRV } from 'src/helpers/interface_helpers';
import { roller_is_calibrated } from 'src/helpers/requests/calibrate_cover';
import { isBluTRVCalibrated } from 'src/helpers/virtual_helpers/blutrv_helpers';
import { devices_settings, devices_status } from 'src/stores';
//Types
import type { Device } from 'src/types/Device';

export const isLocalActionDeviceCalibrated = (device: Device): boolean => {
	if (isBluTRV(device.type)) return isBluTRVCalibrated(device);

	const status = devices_status.getByRealId(device.id);
	if (isTRV(device.type)) return status?.thermostats?.[0]?.pos !== -1;

	return roller_is_calibrated(device, status, devices_settings.getByRealId(device.id));
};
